import type { TableColumns } from '@ohpen/enso-ui';

import type { RolePermissionRow, RoleRow } from './interfaces';
import { renderRole } from './utils';

export const roleColumns: TableColumns<RoleRow> = [
  {
    title: 'config.columns.role',
    dataIndex: 'role',
    key: 'role',
    width: 240,
    options: { filter: 'search', sorter: true, filterOptions: { allowedModes: ['contains'] } },
    render: (role: string, record: RoleRow) => renderRole(role, record),
  },
  { title: 'config.columns.group', dataIndex: 'group', key: 'group', width: 160 },
  { title: 'config.columns.description', dataIndex: 'description', key: 'description', width: 580, options: { filter: 'search' } },
  { title: 'config.columns.permissions', dataIndex: 'count', key: 'count', width: 130 },
];

export const rolePermissionColumns: TableColumns<RolePermissionRow> = [
  {
    title: 'config.columns.permission',
    dataIndex: 'permission',
    key: 'permission',
    width: 320,
    options: { filter: 'search', filterOptions: { allowedModes: ['contains'] } },
  },
  { title: 'config.columns.section', dataIndex: 'resource', key: 'resource', width: 220 },
  { title: 'config.columns.action', dataIndex: 'action', key: 'action', width: 160 },
];
